export class ViewerContainer {
    private width: number;
    private height: number;
    private container: HTMLElement;
    private output: HTMLElement;
    private loader: HTMLElement;
    private outputContent: string;
    private canvas: HTMLCanvasElement;
    private heightProportion: number;

    constructor(canvasId, width, height, container, output, loader) {
        this.width = width;
        this.height = height;
        this.container = container;
        this.output = output;
        this.loader = loader;
        this.outputContent = '';
        this.canvas = this.container.querySelector(canvasId);
        this.heightProportion = height / width;

        this.container.style.maxWidth = `${width}px`;
        this.container.style.width = '100%';

        this.updateContainerHeight();
    }

    appendChild(child) {
        this.container.appendChild(child);
    }

    resetLoader() {
        this.loader.style.display = 'block';
    }

    hideLoader() {
        this.loader.style.display = 'none';
    }

    setLoader(valueInPercent) {
        if (!this.loader.classList.contains('loader-2')) {
            this.loader.classList.add('loader-2');
        }
    }

    getContainerAspect() {
        return this.width / this.height;
    }

    getClientWidth() {
        return this.container.clientWidth;
    }

    getClientHeight() {
        return this.container.clientHeight;
    }

    getHeight() {
        return this.height;
    }

    updateContainerHeight() {
        const height = Math.round(this.getClientWidth() * this.heightProportion);

        this.container.style.height = `${height}px`;
        this.canvas.style.height = `${height}px`;
        this.canvas.height = Math.round(height);
    }

    getCanvas() {
        return this.canvas;
    }

    updateOutput() {
        this.output.innerHTML = this.outputContent;
    }

    clearOutputContent() {
        this.outputContent = '';
    }

    appendOutput(message) {
        this.outputContent += `${message}<br>`;
    }

    appendOutputTime(time) {
        this.appendOutput(`Time: ${parseInt(time)}s`);
    }

    appendDebugOutput(models, gltfs, renderer) {
        this.appendOutput(`Models: ${models.length}`);
        this.appendOutput(`Gltfs: ${gltfs.size}`);
        this.appendOutput(`Geometries: ${renderer.info.memory.geometries}`);
        this.appendOutput(`Textures: ${renderer.info.memory.textures}`);
        this.appendOutput(`Calls: ${renderer.info.render.calls}`);
        this.appendOutput(`Triangles: ${renderer.info.render.triangles}`);
    }
}
